<template>
  <div v-loading.body="loading">
    <el-row class="filter" type="flex">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px" inline>
                <el-form-item label="买手组：">
                  <el-input
                    v-model="form.pg_name"
                    placeholder="买手组"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="市场(地理位置)：" label-width="120px">
                  <el-select
                    v-model="form.market_id"
                    filterable
                    clearable
                    placeholder="市场"
                    @change="onMainMarketChange"
                  >
                    <el-option
                      v-for="item in market"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="子市场：">
                  <el-select
                    v-model="form.market_sub_id"
                    filterable
                    clearable
                    placeholder="子市场"
                  >
                    <el-option
                      v-for="item in subMarketList"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="attributable_market_id"
                  label="业绩归属市场："
                  label-width="120px"
                >
                  <el-select
                    v-model="form.attributable_market_id"
                    filterable
                    clearable
                    placeholder="业绩归属市场"
                    @change="handleSetAttributableSubMarket($event, true)"
                  >
                    <el-option
                      v-for="item in performanceMarketList"
                      :key="item.attributable_market_id"
                      :label="item.attributable_market_name"
                      :value="item.attributable_market_id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="组长">
                  <el-select
                    v-model="form.group_leader"
                    filterable
                    placeholder="组长"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in group_leader"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select
                    v-if="resData"
                    v-model="form.status"
                    placeholder="状态"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="日期">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          v-if="resData"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据汇总 买手组：{{ resData.count }}组</div>
          <el-button
            style="margin-left: auto"
            type="warning"
            size="mini"
            @click="AddPicker(0)"
            >创建买手组
          </el-button>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="market_name"
              label="市场(地理位置)"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_sub_name"
              label="子市场"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="attributable_market_name"
              label="业绩归属市场"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="pg_name" label="买手组" align="center">
            </el-table-column>
            <el-table-column
              prop="admin_leader_name"
              label="组长"
              align="center"
            />
            <el-table-column prop="pg_code" label="代号" align="center">
            </el-table-column>
            <el-table-column
              prop="member_num"
              label="人数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="hexin_supply_num"
              label="已绑定核心档口"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="GoSupplyList(scope.row.pg_id)"
                  >{{ scope.row.hexin_supply_num }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="surplus_bind_num"
              label="剩余可绑定档口数"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.status == 1">启用</div>
                <div v-if="scope.row.status == 0">禁用</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建日期"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="" label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="AddPicker(scope.row.pg_id)"
                  >编辑
                </el-button>
                <el-button
                  size="small"
                  type="text"
                  @click="showLogList(scope.row.pg_id)"
                  >操作日志
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div v-if="showlog">
      <log :id="pg_id" :log-type="log_type" @onCloseDialog="closeBox"></log>
    </div>
    <div v-if="showbox">
      <edit-picker
        :id="pg_id"
        :group_leader="group_leader"
        @onCloseDialog="closeBox"
      ></edit-picker>
    </div>
  </div>
</template>

<script>
import Log from "./components/Log.vue";
import EditPicker from "./components/EditPicker.vue";
import apiBaseURL from "@/utils/baseUrl.js";
import {
  getGetAttributableMarketList,
  postGetChildMarket,
} from "@/openapi/erp/supply.js";
import { getMarketList } from "@/controller/common2302.js";
import { removeFalsy } from "@/utils/utils.js";

export default {
  components: {
    Log,
    EditPicker,
  },
  data() {
    return {
      marketList: [], // 主市场列表
      subMarketList: [], // 子市场列表
      performanceMarketList: [], // 业绩归属市场列表
      log_type: 1,
      pg_id: 0,
      showlog: false,
      showbox: false,
      images: [],
      resData: null,
      form: {
        market_id: "",
        market_sub_id: "",
        status: "",
      },
      loading: false, // 加载动画是否显示
      url: "/erp/PickerGroup/pickerGroupList",
      status: "",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      market: [],
      group_leader: [],
    };
  },
  mounted() {
    this.getMainMarketList();
    this.getGroupLeader();
    this.fetchData();
    this.handleGetPerformanceMarketList();
  },
  methods: {
    getMainMarketList() {
      getMarketList()
        .then((data) => {
          this.market = data;
        })
        .catch(this.$noop);
    },
    // 切换主市场时，重新获取子市场
    onMainMarketChange() {
      postGetChildMarket({ parent_id: this.form.market_id }).then((res) => {
        this.subMarketList = res;
        this.form.market_sub_id = "";
      });
    },
    // 设置业绩归属市场
    handleSetAttributableSubMarket(attributableMarketId, reset) {
      const selectedMainMarket = this.performanceMarketList.find(
        (option) => option.attributable_market_id === attributableMarketId
      );
      this.performanceSubMarketList = selectedMainMarket?.sub_list || [];
      if (
        reset ||
        !this.performanceSubMarketList.length ||
        this.form.attributable_market_sub_id.toString() === "0"
      ) {
        this.form.attributable_market_sub_id = "";
      }
    },
    // 获取业绩归属市场列表
    handleGetPerformanceMarketList() {
      getGetAttributableMarketList()
        .then((res) => {
          this.performanceMarketList = res;
        })
        .catch(this.$noop);
    },
    showLogList(id) {
      this.pg_id = Number(id);
      this.showlog = true;
    },
    AddPicker(id) {
      this.pg_id = Number(id);
      this.showbox = true;
    },
    closeBox() {
      this.showbox = false;
      this.showlog = false;
      this.fetchData();
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, removeFalsy(this.form)).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, removeFalsy(this.form)).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    GoSupplyList(pg_id) {
      this.$router.push(`/home/supply/supplyList?pg_id=${pg_id}`);
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.fetchData();
    },
    // selectMarket() {
    //   this.loading = true;
    //   this.$http.post("/erp/Common/getFirstMarketList").then((res) => {
    //     this.loading = false;
    //     if (res.data.code !== 200) {
    //       return this.$message.error(res.data.msg);
    //     }
    //     this.market = res.data.data;
    //   });
    // },
    getGroupLeader() {
      this.$http.post("/erp/Common/getAdmin").then((res) => {
        if (res.data.code !== 200) {
          return this.$message.error(res.data.msg);
        }
        this.group_leader = res.data.data;
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.demo-form-inline .el-form-item {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/picker/Picker.vue